import { deserialize, fetchWrapper } from '../fetch';
import type { DossierEvent } from './interface';

export const fetchEvents = async (
  dossierId: string
): Promise<DossierEvent[]> => {
  const url = new URL(`/app/v1/dossiers/${dossierId}/events`, API_BASE_URL);
  const data = await deserialize(
    await fetchWrapper(url.href, { method: 'GET', credentials: 'include' })
  );
  return data.events;
};

export const createEvent = async (
  dossierId: string,
  data: {
    event_type: string;
    event_date: string;
    metadata?: Record<string, unknown>;
    escalation_id?: string;
    file_name?: string;
    file_type?: string;
    s3_key?: string;
    s3_bucket?: string;
    title?: string;
  }
): Promise<{ event_id: string; file_id?: string }> => {
  const url = new URL(`/app/v1/dossiers/${dossierId}/events`, API_BASE_URL);
  return deserialize(
    await fetchWrapper(url.href, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-type': 'application/json' },
      body: JSON.stringify(data),
    })
  );
};
